"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setComputeUnitLimit = exports.getSetComputeUnitLimitInstructionDataSerializer = void 0;
const umi_1 = require("@metaplex-foundation/umi");
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const shared_1 = require("../shared");
function getSetComputeUnitLimitInstructionDataSerializer() {
    return (0, serializers_1.mapSerializer)((0, serializers_1.struct)([
        ['discriminator', (0, serializers_1.u8)()],
        ['units', (0, serializers_1.u32)()],
    ], { description: 'SetComputeUnitLimitInstructionData' }), (value) => ({ ...value, discriminator: 2 }));
}
exports.getSetComputeUnitLimitInstructionDataSerializer = getSetComputeUnitLimitInstructionDataSerializer;
// Instruction.
function setComputeUnitLimit(context, input) {
    // Program ID.
    const programId = context.programs.getPublicKey('splComputeBudget', 'ComputeBudget111111111111111111111111111111');
    // Accounts.
    const resolvedAccounts = {};
    // Arguments.
    const resolvedArgs = { ...input };
    // Accounts in order.
    const orderedAccounts = Object.values(resolvedAccounts).sort((a, b) => a.index - b.index);
    // Keys and Signers.
    const [keys, signers] = (0, shared_1.getAccountMetasAndSigners)(orderedAccounts, 'programId', programId);
    // Data.
    const data = getSetComputeUnitLimitInstructionDataSerializer().serialize(resolvedArgs);
    // Bytes Created On Chain.
    const bytesCreatedOnChain = 0;
    return (0, umi_1.transactionBuilder)([
        { instruction: { keys, programId, data }, signers, bytesCreatedOnChain },
    ]);
}
exports.setComputeUnitLimit = setComputeUnitLimit;
//# sourceMappingURL=setComputeUnitLimit.js.map